// Is this page being served as the production site?
//
// Decided at runtime from the hostname, not at build time, so ONE build behaves correctly
// wherever it is served - production, staging.vegamrobotics.com, the VPN address, or
// localhost. A build flag would fail open: forget it once and staging submissions land in
// the production lead sheet again, which is the bug this replaced (2026-09-17).
//
// Fails closed. Any hostname not listed here is treated as non-production, so outbound
// lead and email integrations stay off. If production ever gains a new hostname, add it
// here - otherwise that host's Contact submissions go to the container's own /api/contact
// CSV instead of the Google Sheet.
const PRODUCTION_HOSTNAMES = ["vegamrobotics.com", "www.vegamrobotics.com"];

export function isProductionHostname(hostname: string): boolean {
  return PRODUCTION_HOSTNAMES.includes(hostname.toLowerCase());
}

export function isProductionSite(): boolean {
  return typeof window !== "undefined" && isProductionHostname(window.location.hostname);
}
